var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"app-header"},[_c('div',{staticClass:"app-header__row"},[_vm._t("default",function(){return [_c('VHeader')]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }